G.SliderPanel = function(x,y,width,height,content,config) {

	Phaser.Group.call(this,game);

	this.sliderWidth = G.l(width);
	this.sliderHeight = G.l(height);

	this.x = x + (this.sliderWidth*-0.5);
	this.y = y + (this.sliderHeight*-0.5);

	//slider mask
	this.gfxMask = game.add.graphics();
	
	this.gfxMask.beginFill(0x000000,1);
	this.gfxMask.drawRect(0,0,width,height);
	
	this.clickableObjects = [];

	this.config = config;
	this.applyConfig(this.config);

	this.addContent(content);
	this.add(this.gfxMask);
	//this.contentGroup.add(this.gfxMask);
	this.contentGroup.mask = this.gfxMask;

	this.slideY = 0;

	

	this.inputSprite = G.makeImage(0,0,null,0,this);
	this.inputSprite.inputEnabled = true;
	this.inputSprite.hitArea = new Phaser.Rectangle(0,0,width,height);

	this.inputSpriteDown = false;

	this.inputData = {
		x: null,
		y: null,
		velX: 0,
		velY: 0,
		xStart: null,
		yStart: null,
		startFrameStamp: null,
		clickDistanceWindow: 10,
		clickTimeWindow: 10,

	};

	//blocks input from buttons bellow
	this.inputSprite.events.onInputDown.add(function(pointer) {
		var p = game.input.activePointer;
		this.inputSpriteDown = true;
		this.inputData.x = this.inputData.xStart = p.worldX;
		this.inputData.y = this.inputData.yStart = p.worldY;
		this.inputData.startFrameStamp = this.frameCounter;
	},this);

	this.inputSprite.events.onInputUp.add(function() {
		var p = game.input.activePointer;
		this.inputSpriteDown = false;
		
		var distance = game.math.distance(this.inputData.xStart,this.inputData.yStart,p.worldX,p.worldY);
		var timeDelta = this.frameCounter - this.inputData.startFrameStamp;

		if (distance <= this.inputData.clickDistanceWindow && timeDelta <= this.inputData.clickTimeWindow) {
			this.propagateClick(p.x,p.y);
			this.inputData.velX = 0;
			this.inputData.velY = 0;
		}

	},this);

	//frameCounter for measuring click window
	//if I would use timestamps during low fps buttons could not work
	this.frameCounter = 0;

};

G.SliderPanel.prototype = Object.create(Phaser.Group.prototype);

G.SliderPanel.prototype.applyConfig = function(config) {

	this.horizontal = config.horizontal || false;
	this.horizontalLerp = config.horizontalLerp || false;
	this.vertical = config.vertical || true;
	this.verticalLerp = config.verticalLerp;

};

//group is at 0,0;
G.SliderPanel.prototype.addContent = function(group) {

	this.changeInputSettings(group);

	this.contentGroup = group;
	this.add(group);
	this.contentGroup.x = 0;

	this.contentGroupMinY = -this.contentGroup.height+this.sliderHeight;
	this.contentGroupMaxY = 0;
	this.contentGroupMinX = this.sliderWidth-this.contentGroup.width;
	this.contentGroupMaxX = 0;


};

//we have to change input settings, because buttons that are not visible
//are not covered by input sprite and they would be clickable
G.SliderPanel.prototype.changeInputSettings = function(group) {

	for (var i = group.children.length; i--; ) {
		var child = group.children[i];
		if (child.inputEnabled) {
			this.clickableObjects.push(child);
			child.inputEnabled = false;
		}
		if (child.children.length > 0) {
				this.changeInputSettings(child);
		}
	}

};

G.SliderPanel.prototype.update = function() {

	this.frameCounter++;

	if (this.inputSpriteDown && game.input.activePointer.isDown) {

		var difX = this.inputData.x - game.input.activePointer.worldX;
		var difY = this.inputData.y - game.input.activePointer.worldY;

		this.inputData.x = game.input.activePointer.worldX;
		this.inputData.y = game.input.activePointer.worldY;

		this.inputData.velX = 0.8 * (difX) + 0.2 * this.inputData.velX;
		this.inputData.velY = 0.8 * (difY) + 0.2 * this.inputData.velY;

		if (this.horizontal) {
			this.contentGroup.x -= this.inputData.velX;
		}

		if (this.vertical) {
			this.contentGroup.y -= this.inputData.velY;
		}

	}else {

		if (this.horizontal) {
			this.contentGroup.x -= this.inputData.velX;
			this.inputData.velX *= 0.95;
			if (Math.abs(this.inputData.velX) < 1) {
				this.inputData.velX = 0;
			}
		}

		if (this.vertical) {
			this.contentGroup.y -= this.inputData.velY;
			this.inputData.velY *= 0.95;
			if (Math.abs(this.inputData.velY) < 1) {
				this.inputData.velY = 0;
			}
		}
		
	}

	if (this.vertical) {
		this.boundRestrict('y',this.verticalLerp,this.contentGroupMinY,this.contentGroupMaxY);
	}

	if (this.horizontal) {
		this.boundRestrict('x',this.horizontalLerp,this.contentGroupMinX,this.contentGroupMaxX);
	}

	this.boundRestrict();
	

};

G.SliderPanel.prototype.propagateClick = function(pX,pY) {

	for (var i = 0; i < this.clickableObjects.length; i++) {
		if (this.clickableObjects[i].visible && this.clickableObjects[i].getBounds().contains(pX,pY)) {
			this.clickableObjects[i].onInputDown.dispatch();
			break;
		}
	}

};


G.SliderPanel.prototype.boundRestrict = function(prop,lerp,min,max) {

	if (lerp) {
		
		if (this.contentGroup[prop] > max) {
			this.contentGroup[prop] = G.lerp(this.contentGroup[prop],max,0.5);
			if (this.contentGroup[prop] < max+1 ) {
				this.contentGroup[prop] = max;
			}
		}

		if (this.contentGroup[prop] < min) {
			this.contentGroup[prop] = G.lerp(this.contentGroup[prop],min,0.2);
			if (this.contentGroup[prop] > min-1) {
				this.contentGroup[prop] = min;
			}
		}

	}else {

		this.contentGroup[prop] = game.math.clamp(this.contentGroup[prop],min,max);

	}

};